module.exports = __webpack_public_path__ + "static/CHIME_PRESHOW_ACT_2-674a2e094cd3288390d6f5ee10f7230c.mp4";